import PageHeader from "../../components/Header/PageHeader";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import "./style.css";
import React, { useEffect, useState } from "react";
import { fetchWrapper } from "../../helpers";
import {
    Layout, Row, Col, Card, Space, Typography, Button, Divider, Select, Modal,
    Tag, Avatar, Descriptions, Input, Alert, message
} from "antd";
import {
    ArrowLeftOutlined, GlobalOutlined, SettingOutlined, CrownOutlined,
    LinkedinOutlined, FacebookOutlined, InstagramOutlined, EnvironmentOutlined
} from "@ant-design/icons";

import { useDebounce } from "use-debounce";
import i18n from "i18next";
import { getProvidersUrls } from "../../utils/auth";
import { PROVIDER } from "../../constants/auth";
import settingsIcon from "../icons/settings-icon.svg";
import xIcon from "../icons/linkedin-icon.svg";
import fbIcon from "../icons/facebook-icon.svg";
import instIcon from "../icons/instagram-logo.png";
import { authActions } from "../../store";
import { useDispatch } from "react-redux";
import moment from "moment";
import crownIcon from "../icons/crown.png";
import InviteFriend from "../../components/Forms/InviteFriend";
import ReferralsModal from "../../components/modals/Referrals-modal";
import axios from "axios";
import { getUserTimeInfo } from "../../helpers/get-user-time-zone";
import TimeZoneModal from "../../components/modals/TimeZone-modal";
import RemoveAccountModal from "../../components/modals/Remove-account-modal";
import { useOrganization } from "../../context/organizationContext";
import OrganizationSettings from "../../components/blocks/OrganizationSettings";
import OrganizationLogo from "../../components/blocks/OrganizationLogo";
import { getUserCoordinates } from "../../utils/getUserCoordinates";
import AppNavigation from "../../components/AppNavigation";
import DownloadReportButton from "../../components/PDFDownloadButton/PDFDownloadButton";
import {ImeanHeader} from "../../components/Header/Header";
import {normalizeLang } from "../../utils/LangUtils/langStorage";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const ProfilePage = () => {
    // const prms = new URLSearchParams(window.location.search);
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const [handleUpdateProfile, sethandleUpdateProfile] = useState(false);
    const navigate = useNavigate();
    const user = useSelector((obj) => obj.auth.user);
    const org = useOrganization();
    const [profile, setProfile] = useState(null);
    const [currentTimeZone, setCurrentTimeZone] = useState(getUserTimeInfo());
    const [linkedInModalVisible, setLinkedInModalVisible] = useState(false);
    const [fbModalVisible, setFBModalVisible] = useState(false);
    const [fbModalInfoVisible, setFBModalInfoVisible] = useState(searchParams.get("helpFbModal") === "true" ? true : false);
    const [instModalInfoVisible, setInstModalInfoVisible] = useState(false);
    const [timeZones, setTimeZones] = useState([]);
    const [genLang, setGenLang] = useState();
    const [gender, setGender] = useState();
    const [name, setName] = useState(user.name);
    const [position, setPosition] = useState("");
    const [industry, setIndustry] = useState("");
    const [subDateEnd, setSubDateEnd] = useState();
    const [subLevel, setSubLevel] = useState();
    const [updateName] = useDebounce(name, 1000);
    const [updatePosition] = useDebounce(position, 1000);
    const [updateIndustry] = useDebounce(industry, 1000);
    const [handleUpdateReferrals, sethandleUpdateReferrals] = useState(false);
    const [fbPages, setFbPages] = useState([]);
    const [linkedInPages, setLinkedInPages] = useState([]);
    const [socialMediaUsers, setSocialMediaUsers] = useState({
        facebook: {},
        instagram: {},
        linkedIn: {},
    });
    const [tokensIds, setTokensIds] = useState({
        facebook: "",
        instagram: "",
        linkedIn: "",
    });
    const [tokens, setTokens] = useState({
        facebook: false,
        instagram: false,
        linkedIn: false,
    });
    const [sid, setSid] = useState(jwtDecode(JSON.parse(localStorage.getItem("user")).accessToken).subscriptionLevel.id);
    const dispatch = useDispatch();
    const socialLogin = {
        linkedIn: () => {
            fetchWrapper
                .get(`${baseUrl}/auth/special-url?sn=linkedin`)
                .then((res) => {
                    if (res?.redirect_url) {
                        window.location = res.redirect_url;
                    } else {
                        window.location = getProvidersUrls()[PROVIDER.LINKEDIN];
                    }
                })
                .catch((err) => {
                    console.error(err);
                    window.location = getProvidersUrls()[PROVIDER.LINKEDIN];
                });
            //   console.log(getProvidersUrls()[PROVIDER.LINKEDIN]);
            // window.location = getProvidersUrls()[PROVIDER.LINKEDIN];
        },
        facebook: () => {
            fetchWrapper
                .get(`${baseUrl}/auth/special-url?sn=facebook`)
                .then((res) => {
                    if (res?.redirect_url) {
                        window.location = res.redirect_url;
                    } else {
                        window.location = getProvidersUrls()[PROVIDER.FACEBOOK];
                    }
                })
                .catch((err) => {
                    console.error(err);
                    window.location = getProvidersUrls()[PROVIDER.FACEBOOK];
                });
            //   console.log(getProvidersUrls()[PROVIDER.LINKEDIN]);
            // window.location = getProvidersUrls()[PROVIDER.FACEBOOK];
        },
        instagram: () => {
            fetchWrapper
                .get(`${baseUrl}/auth/special-url?sn=instagram`)
                .then((res) => {
                    if (res?.redirect_url) {
                        window.location = res.redirect_url;
                    } else {
                        window.location = getProvidersUrls()[PROVIDER.INSTAGRAM];
                    }
                })
                .catch((err) => {
                    console.error(err);
                    window.location = getProvidersUrls()[PROVIDER.INSTAGRAM];
                });
            //   console.log(getProvidersUrls()[PROVIDER.LINKEDIN]);
        },
    };

    const socialUnhook = {
        linkedIn: () => {
            if (window.confirm(t("profile.unlinkLinkedinConfrim"))) {
                fetchWrapper.get(`${baseUrl}/unhook/linkedin/${tokensIds.linkedIn}`).then((res) => {
                    if (res) {
                        setTokens((prevState) => ({ ...prevState, linkedIn: false }));
                        refreshToken();
                    }
                });
            }
        },
        facebook: () => {
            if (window.confirm(t("profile.unlinkFacebookConfrim"))) {
                fetchWrapper.get(`${baseUrl}/unhook/facebook/${tokensIds.facebook}`).then((res) => {
                    if (res) {
                        setTokens((prevState) => ({ ...prevState, facebook: false }));
                        refreshToken();
                    }
                });
            }
        },
        instagram: () => {
            if (window.confirm(t("profile.unlinkInstagramConfrim"))) {
                fetchWrapper.get(`${baseUrl}/unhook/instagram/${tokensIds.instagram}`).then((res) => {
                    if (res) {
                        setTokens((prevState) => ({ ...prevState, instagram: false }));
                        refreshToken();
                    }
                });
            }
        },
    };

    useEffect(() => {
        fetchWrapper
            .get(`${baseUrl}/auth/getSocialMediaTokens/`)
            .then((res) => {
                const socialUsers = {
                    facebook: null,
                    instagram: null,
                    linkedIn: null,
                };
                const newTokensId = {
                    facebook: "",
                    instagram: "",
                    linkedIn: "",
                };
                const filteredToken = {
                    facebook: false,
                    instagram: false,
                    linkedIn: false,
                };
                res.forEach((token) => {
                    if (token.socialMediaType === "FACEBOOK") {
                        filteredToken.facebook = true;
                        newTokensId.facebook = token.id;
                        socialUsers.facebook = { username: token?.username, email: token?.email };
                    }
                    if (token.socialMediaType === "INSTAGRAM") {
                        filteredToken.instagram = true;
                        newTokensId.instagram = token.id;
                        socialUsers.instagram = { username: token?.username, email: token?.email };
                    }
                    if (token.socialMediaType === "LINKEDIN") {
                        // console.log(token)
                        filteredToken.linkedIn = true;
                        newTokensId.linkedIn = token.id;
                        socialUsers.linkedIn = { username: token?.username, email: token?.email };
                    }
                });
                setSocialMediaUsers(socialUsers);
                setTokens(filteredToken);
                setTokensIds(newTokensId);
            })
            .catch(() => {});
    }, []);
    const refreshToken = () => {
        fetchWrapper.get(`${baseUrl}/auth/refresh-token`).then((res) => {
            const saved = localStorage.getItem("user");
            if (!saved) return;
            const oldUser = JSON.parse(localStorage.getItem("user"));
            oldUser.languageGeneration = genLang;
            oldUser.name = name;
            oldUser.accessToken = res.accessToken;
            localStorage.setItem("user", JSON.stringify(oldUser));
            setSubDateEnd(jwtDecode(res?.accessToken)?.userSubscription?.endDate);
            setSubLevel(jwtDecode(res?.accessToken)?.subscriptionLevel);
            dispatch(authActions.updateUser());
        });
    };

    const onChangeLanguage = (value) => {
        const ln = normalizeLang(value);
        setGenLang(ln);
    };

    const handleChangeGender = (gender) => {
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                gender: gender,
            })
            .then((res) => {
                if (res) {
                    setGender(gender);
                }
            });
    };

    const onChangeTimeZone = (TZ) => {
        setCurrentTimeZone(TZ);
        fetchWrapper.post(`${baseUrl}/profile/update-info`, {
            timeZone: TZ,
        });
    };

    const showLinkedInModal = () => {
        setLinkedInModalVisible(true);
    };

    const showFBModal = () => {
        setFBModalVisible(true);
    };

    const showFBModalInfo = () => {
        setFBModalInfoVisible(true);
    };

    const showInstModalInfo = () => {
        setInstModalInfoVisible(true);
    };

    const handleChangeFBPage = (page) => {
        setFBModalVisible(false);
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                facebookPageId: page.id,
            })
            .then((res) => {
                if (res) {
                    sethandleUpdateProfile((p) => !p);
                }
            });
    };

    const handleChangeLinkedInPage = (page) => {
        setLinkedInModalVisible(false);
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                linkedinPageId: page.page_id,
            })
            .then((res) => {
                if (res) {
                    sethandleUpdateProfile((p) => !p);
                }
            });
    };

    const shareGeoData = async () => {
        let coordinates = null;
        try {
            coordinates = await getUserCoordinates();
        } catch (e) {
            console.error(e);
            message.error(t("profile.sharedGeoDataError"));
        }
        fetchWrapper
            .post(`${baseUrl}/profile/update-info`, {
                coordinates,
            })
            .then((res) => {
                if (res) {
                    message.success(t("profile.sharedGeoDataSuccess"));
                } else {
                    message.error(t("profile.sharedGeoDataError"));
                }
            })
            .catch(() => {
                message.error(t("profile.sharedGeoDataError"));
            });
    };

    useEffect(() => {
        refreshToken();

        axios
            .get("/data/utc-zones.json")
            .then((res) => {
                setTimeZones(res.data);
            })
            .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/profile/`).then((res) => {
            const ln = normalizeLang(res.languageGeneration)
            setGenLang(ln);
            setProfile(res);
            if (res.timeZone) {
                setCurrentTimeZone(res.timeZone);
            }
            if (res.position) {
                setPosition(res.position);
            }
            if (res.industry) {
                setIndustry(res.industry);
            }
            if (res.gender) {
                setGender(res.gender || "other");
            } else {
                setGender("other");
            }
        });

        try {
            fetchWrapper
                .get(`${baseUrl}/profile/facebook-pages`)
                .then((res) => {
                    if (res) {
                        if (res === "facebook_pages_not_found") {
                            navigate("?helpFbModal=true");
                            setFBModalInfoVisible(true);
                        } else {
                            setFbPages(res);
                        }
                    } else {
                        navigate("?helpFbModal=true");
                        setFBModalInfoVisible(true);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err === "facebook_pages_not_found") {
                        navigate("?helpFbModal=true");
                        setFBModalInfoVisible(true);
                    }
                });
        } catch (err) {
            console.error("facebook pages error:", err);
        }

        try {
            fetchWrapper
                .get(`${baseUrl}/profile/linkedin-pages`)
                .then((res) => {
                    if (res) {
                        setLinkedInPages(res);
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        } catch (err) {
            console.error("linkedin pages error:", err);
        }
    }, [handleUpdateProfile]);

    useEffect(() => {
        fetchWrapper.post(`${baseUrl}/profile/update-info`, {
            languageGeneration: genLang,
        });
        refreshToken();
    }, [genLang]);

    useEffect(() => {
        if (updateName) {
            fetchWrapper.post(`${baseUrl}/profile/update-info`, { name: updateName }).then(() => {
                refreshToken();
            });
        }
    }, [updateName]);

    useEffect(() => {
        if (updatePosition) {
            fetchWrapper.post(`${baseUrl}/profile/update-info`, { position: updatePosition }).then(() => {
                refreshToken();
            });
        }
    }, [updatePosition]);

    useEffect(() => {
        if (updateIndustry) {
            fetchWrapper.post(`${baseUrl}/profile/update-info`, { industry: updateIndustry }).then(() => {
                refreshToken();
            });
        }
    }, [updateIndustry]);

    useEffect(() => {
        if (!profile?.linkedinPageId && linkedInPages.length) {
            fetchWrapper
                .post(`${baseUrl}/profile/update-info`, {
                    linkedinPageId: linkedInPages[0]?.page_id,
                })
                .then((res) => {
                    if (res) {
                        sethandleUpdateProfile((p) => !p);
                    }
                });
        }
    }, [profile, linkedInPages]);

    console.log("user: ", user);
    console.log("organization: ", org);
    return (
        <Layout className="min-h-screen bg-gradient-to-b from-white to-violet-50">
            {/* Top bar */}
            <ImeanHeader initialDark={true}></ImeanHeader>
            <Layout.Header
                className="!bg-white/80 backdrop-blur-md border-b border-gray-100"
                style={{ position: "sticky", top: 0, zIndex: 50 }}
            >
                <Row align="middle" justify="space-between" className="max-w-6xl mx-auto w-full">
                    <Space>
                        <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate("/home")}>
                            {t("functions.previous")}
                        </Button>
                        <Typography.Title level={4} style={{ margin: 0 }}>{t("profile.header")}</Typography.Title>
                    </Space>
                    {!!sid && <Tag icon={<CrownOutlined />} color="purple">Premium</Tag>}
                </Row>
            </Layout.Header>

            {/* Main content */}
            <Layout.Content className="max-w-6xl mx-auto w-full px-4 md:px-6 lg:px-8 py-6">
                <Row gutter={[16, 16]}>
                    {/* LEFT: Profile summary & preferences */}
                    <Col xs={24} lg={10}>
                        <Card
                            className="shadow-sm rounded-2xl"
                            bodyStyle={{ padding: 16 }}
                            title={<Space><Avatar shape="square" size={40}><span className="font-semibold">U</span></Avatar><span>{t("profile.header")}</span></Space>}
                            extra={subDateEnd ? <Tag color="green">Active till {moment(subDateEnd).format("DD/MM/YYYY")}</Tag> : null}
                        >
                            <Space direction="vertical" size={12} className="w-full">
                                <OrganizationLogo />

                                <Descriptions column={1} labelStyle={{ width: 120 }}>
                                    <Descriptions.Item label={t("profile.name")}>
                                        <Space className="w-full">
                                            <Input
                                                className="w-full"
                                                size="middle"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                placeholder="Your full name"
                                            />
                                            {!!sid && <img className="h-5 w-5" src={crownIcon} alt="premium" />}
                                        </Space>
                                    </Descriptions.Item>

                                    <Descriptions.Item label={t("profile.login")}>
                                        <Typography.Text type="secondary" className="truncate">{user.email}</Typography.Text>
                                    </Descriptions.Item>

                                    {org?.organization?.id && (
                                        <>
                                            <Descriptions.Item label={t("profile.position")} labelStyle={{ whiteSpace: "nowrap" }}>
                                                <Input
                                                    size="middle"
                                                    value={position}
                                                    onChange={(e) => setPosition(e.target.value)}
                                                    placeholder="Not set"
                                                />
                                            </Descriptions.Item>

                                            <Descriptions.Item label={t("profile.industry")}  labelStyle={{ whiteSpace: "normal" }}>
                                                <Input
                                                    size="middle"
                                                    value={industry}
                                                    onChange={(e) => setIndustry(e.target.value)}
                                                    placeholder="Not set"
                                                />
                                            </Descriptions.Item>
                                        </>
                                    )}

                                    <Descriptions.Item label={t("profile.gender")}>
                                        <Select
                                            size="middle"
                                            value={gender}
                                            className="min-w-[160px]"
                                            onChange={handleChangeGender}
                                            options={[
                                                { value: "male", label: "Male" },
                                                { value: "female", label: "Female" },
                                                { value: "other", label: "Other" },
                                            ]}
                                        />
                                    </Descriptions.Item>

                                    <Descriptions.Item label={t("profile.lang")}>
                                        <Select
                                            size="middle"
                                            value={genLang}
                                            className="min-w-[160px]"
                                            onChange={onChangeLanguage}
                                            options={[
                                                { value: "kk", label: "Қазақша" },
                                                { value: "ru", label: "Русский" },
                                                { value: "en", label: "English" },
                                            ]}
                                        />
                                    </Descriptions.Item>

                                    {!!timeZones.length && (
                                        <Descriptions.Item label={t("profile.timeZone")}>
                                            <Space>
                                                <GlobalOutlined />
                                                <Select
                                                    value={currentTimeZone}
                                                    className="min-w-[220px]"
                                                    onChange={onChangeTimeZone}
                                                    options={timeZones}
                                                />
                                                <TimeZoneModal />
                                            </Space>
                                        </Descriptions.Item>
                                    )}
                                </Descriptions>

                                <Alert
                                    type="info"
                                    showIcon
                                    className="rounded-lg"
                                    message={
                                        <Space>
                                            <EnvironmentOutlined />
                                            <span>{t("profile.shareLocationExplanation")}</span>
                                        </Space>
                                    }
                                    action={
                                        <Button size="small" type="primary" onClick={shareGeoData}>
                                            {profile?.coordinates?.length ? t("profile.buttons.reshare") : t("profile.buttons.share")}
                                        </Button>
                                    }
                                />
                            </Space>

                            <Divider />

                            {org?.organization?.id ? (
                                <Space direction="vertical" size={16} className="w-full">
                                    <Typography.Title level={5} style={{ margin: 0 }}>{t("profile.organizationTitle")}</Typography.Title>
                                    <OrganizationSettings />
                                </Space>
                            ) : (
                                <Space direction="vertical" size={12} className="w-full">
                                    <Button
                                        type="primary"
                                        className="!bg-violet-600 hover:!bg-violet-500"
                                        onClick={() => navigate("/subscription-plans")}
                                        block
                                    >
                                        {t("profile.subscriptionManagement")}
                                    </Button>
                                    <InviteFriend handleUpdate={sethandleUpdateReferrals} />
                                    <ReferralsModal handleUpdate={handleUpdateReferrals} />
                                    <RemoveAccountModal handleUpdate={sethandleUpdateProfile} profile={profile} />
                                </Space>
                            )}
                        </Card>
                    </Col>

                    {/* RIGHT: Social connections */}
                    <Col xs={24} lg={14}>
                        <Card className="shadow-sm rounded-2xl" bodyStyle={{ padding: 16 }} title={t("profile.socialConnectionsTitle")}>
                            <Space direction="vertical" size={12} className="w-full">
                                {/* LinkedIn */}
                                <Card
                                    size="small"
                                    className="rounded-xl"
                                    bodyStyle={{ padding: 12 }}
                                    actions={[
                                        tokens.linkedIn ? (
                                            <Button danger onClick={() => socialUnhook.linkedIn()} key="unlink">
                                                {t("profile.buttons.unlink")}
                                            </Button>
                                        ) : (
                                            <Button type="primary" onClick={() => socialLogin.linkedIn()} key="link">
                                                {t("profile.buttons.link")}
                                            </Button>
                                        ),
                                        tokens.linkedIn ? (
                                            <Button icon={<SettingOutlined />} onClick={() => setLinkedInModalVisible(true)} key="settings">
                                                {t("profile.buttons.pages")}
                                            </Button>
                                        ) : null,
                                    ].filter(Boolean)}
                                >
                                    <Space align="start" className="w-full" wrap>
                                        <Avatar size={40} style={{ background: "#1677ff" }} icon={<LinkedinOutlined />} />
                                        <Space direction="vertical" size={0} className="min-w-0">
                                            <Typography.Text strong>LinkedIn</Typography.Text>
                                            {tokens.linkedIn ? (
                                                <Typography.Text type="secondary" className="truncate block">
                                                    {socialMediaUsers?.linkedIn?.username?.toLowerCase().includes("couldnt fetch")
                                                        ? "Account linked (details unavailable)"
                                                        : socialMediaUsers?.linkedIn?.username}
                                                </Typography.Text>
                                            ) : (
                                                <Typography.Text type="secondary">{t("profile.hintConnectLinkedIn")}</Typography.Text>
                                            )}
                                        </Space>
                                    </Space>
                                </Card>

                                {/* Facebook (respect hide flag) */}
                                {process.env.REACT_APP_IS_HIDE_FACEBOOK !== "true" && (
                                    <Card
                                        size="small"
                                        className="rounded-xl"
                                        bodyStyle={{ padding: 12 }}
                                        actions={[
                                            tokens.facebook ? (
                                                <Button danger onClick={() => socialUnhook.facebook()} key="unlink">
                                                    {t("profile.buttons.unlink")}
                                                </Button>
                                            ) : (
                                                <Button type="primary" onClick={() => socialLogin.facebook()} key="link">
                                                    {t("profile.buttons.link")}
                                                </Button>
                                            ),
                                            <Button
                                                icon={<SettingOutlined />}
                                                onClick={() => (tokens.facebook ? setFBModalVisible(true) : setFBModalInfoVisible(true))}
                                                key="settings"
                                            >
                                                {t("profile.buttons.pages")}
                                            </Button>,
                                        ]}
                                    >
                                        <Space align="start" className="w-full" wrap>
                                            <Avatar size={40} style={{ background: "#1877f2" }} icon={<FacebookOutlined />} />
                                            <Space direction="vertical" size={0} className="min-w-0">
                                                <Typography.Text strong>Facebook</Typography.Text>
                                                {tokens.facebook ? (
                                                    <Typography.Text type="secondary" className="truncate block">
                                                        {socialMediaUsers?.facebook?.username?.toLowerCase().includes("couldnt fetch")
                                                            ? "Account linked (details unavailable)"
                                                            : socialMediaUsers?.facebook?.username}
                                                    </Typography.Text>
                                                ) : (
                                                    <Typography.Text type="secondary">{t("profile.hintConnectFacebook")}</Typography.Text>
                                                )}
                                            </Space>
                                        </Space>
                                    </Card>
                                )}

                                {/* Instagram */}
                                <Card
                                    size="small"
                                    className="rounded-xl"
                                    bodyStyle={{ padding: 12 }}
                                    actions={[
                                        tokens.instagram ? (
                                            <Button danger onClick={() => socialUnhook.instagram()} key="unlink">
                                                {t("profile.buttons.unlink")}
                                            </Button>
                                        ) : (
                                            <Button type="primary" onClick={() => socialLogin.instagram()} key="link">
                                                {t("profile.buttons.link")}
                                            </Button>
                                        ),
                                        !tokens.instagram ? (
                                            <Button onClick={() => setInstModalInfoVisible(true)} key="help">
                                                {t("profile.buttons.help")}
                                            </Button>
                                        ) : null,
                                    ].filter(Boolean)}
                                >
                                    <Space align="start" className="w-full" wrap>
                                        <Avatar size={40} style={{ background: "linear-gradient(135deg,#f58529,#feda77,#dd2a7b,#8134af,#515bd4)" }}>
                                            <InstagramOutlined />
                                        </Avatar>
                                        <Space direction="vertical" size={0} className="min-w-0">
                                            <Typography.Text strong>Instagram</Typography.Text>
                                            {tokens.instagram ? (
                                                <Typography.Text type="secondary" className="truncate block">
                                                    {socialMediaUsers?.instagram?.username?.toLowerCase()?.includes("couldnt fetch")
                                                        ? "Account linked (details unavailable)"
                                                        : socialMediaUsers?.instagram?.username}
                                                </Typography.Text>
                                            ) : (
                                                <Typography.Text type="secondary">{t("profile.hintConnectInstagram")}</Typography.Text>
                                            )}
                                        </Space>
                                    </Space>
                                </Card>
                            </Space>
                        </Card>

                        {/* Modals (keep your existing logic) */}
                        {tokens.linkedIn && (
                            <Modal
                                open={linkedInModalVisible}
                                title="Select LinkedIn Page"
                                onCancel={() => setLinkedInModalVisible(false)}
                                footer={null}
                            >
                                <div className="flex flex-col gap-2 pt-2">
                                    {linkedInPages?.length ? (
                                        linkedInPages.map((page, i) => (
                                            <Button
                                                key={i}
                                                block
                                                type={page?.page_id === profile?.linkedinPageId ? "primary" : "default"}
                                                onClick={() =>
                                                    page?.page_id === profile?.linkedinPageId
                                                        ? setLinkedInModalVisible(false)
                                                        : handleChangeLinkedInPage(page)
                                                }
                                            >
                                                {page?.name}
                                            </Button>
                                        ))
                                    ) : (
                                        <div className="text-center my-8">
                                            <Typography.Text>{t("profile.noPagesLinkedIn")}</Typography.Text>
                                            <div className="mt-3">
                                                <Button type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Modal>
                        )}

                        <Modal
                            open={fbModalVisible}
                            title="Select Facebook Page"
                            onCancel={() => setFBModalVisible(false)}
                            footer={null}
                        >
                            <div className="flex flex-col gap-2 pt-2">
                                {fbPages?.length ? (
                                    fbPages.map((page, i) => (
                                        <Button
                                            key={i}
                                            block
                                            type={page?.id === profile?.facebookPageId ? "primary" : "default"}
                                            onClick={() =>
                                                page?.id === profile?.facebookPageId ? setFBModalVisible(false) : handleChangeFBPage(page)
                                            }
                                        >
                                            {page?.name}
                                        </Button>
                                    ))
                                ) : (
                                    <div className="text-center my-8">
                                        <Typography.Text>{t("profile.noPagesFB")}</Typography.Text>
                                        <div className="mt-3">
                                            <Button type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Modal>

                        <Modal
                            open={fbModalInfoVisible}
                            title="Facebook Help"
                            onCancel={() => {
                                setFBModalInfoVisible(false);
                                setSearchParams({});
                            }}
                            footer={null}
                        >
                            <Space direction="vertical" className="w-full">
                                <Typography.Paragraph>
                                    {t("profile.hintFacebookHelp")}
                                </Typography.Paragraph>
                                <Button type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                            </Space>
                        </Modal>

                        {!tokens.instagram && (
                            <Modal
                                open={instModalInfoVisible}
                                title="Instagram Help"
                                onCancel={() => setInstModalInfoVisible(false)}
                                footer={null}
                            >
                                <Space direction="vertical" className="w-full">
                                    <Typography.Paragraph>
                                        {t("profile.hintInstagramHelp")}
                                    </Typography.Paragraph>
                                    <Button type="link" onClick={() => navigate("/guideline")}>Open Setup Guide</Button>
                                </Space>
                            </Modal>
                        )}
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    );

};
